"use client";

import { LazyMotion } from "framer-motion";

const loadFeatures = () =>
  import("@/lib/motion/domAnimation").then((mod) => mod.default);

export const FramerMotionProvider = ({ children }) => {
  return (
    <LazyMotion features={loadFeatures} strict>
      {children}
    </LazyMotion>
  );
};
